<template>
        <router-link v-if="originalValue == null" @click="setCustomer" :to="usersUrl" class="d-flex justify-center align-center pa-0 fill-height" >
            <v-icon v-if="originalValue == null" color="primary" :icon="mdiAccountCogOutline" class="cursor-pointer" size="x-large"/>
        </router-link>
        <span v-else>{{ originalValue }}</span>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { mdiAccountCogOutline } from '@mdi/js';

const props = defineProps(['params']);

const originalValue = ref(null);
const usersUrl = ref('/Users');
let customerReference = null;

onBeforeMount(() => {
if (!props.params.node.group && props.params.colDef.field == 'users' && props.params.node.rowPinned != 'bottom')
    customerReference = JSON.stringify(props.params.node.data);

// ROW PINNED BOTTOM
else
    originalValue.value = '';
});


function setCustomer() {
    localStorage.setItem('activeCustomer', customerReference);
}
</script>
